<template>
  <div class="mx-2 mt-3">
    <div class="row gy-2">
      <div class="col col-12 pb-2">
        <div class="border border-1 border-dark pb-1">
          <p class="tituloColorMas mb-0 ms-2 mt-1">PLAN DE CUENTAS</p>
          <p class="text-secondary mb-0 ms-2 mt-0">MANTENIMIENTO</p>
        </div>
      </div>
    </div>

    <div class="border border-1 pb-2 pt-2 px-2 mt-2">
      <div class="row">
        <div class="col col-3">
          <label class="tamaño" for="">Empresa:</label>
          <select
            class="form-select tamaño ms-1 container"
            aria-label="Default select example"
            @change="empresaRuc = $event.target.value"
          >
            <option disabled selected>Seleccionar Empresa..</option>
            <option
              v-for="Empresa in Empresas"
              :key="Empresa.id"
              :value="Empresa.empRuc"
            >
              {{ Empresa.empRazSocial }}
            </option>
          </select>
        </div>

        <div class="col col-3">
          <label class="tamaño"> Ejercicio:</label>
          <!-- <select
            class="form-select tamaño ms-1 container"
            aria-label="Default select example"
            @change="años = $event.target.value"
          >
            <option disabled selected>Seleccionar Empresa..</option>
            <option v-for="años in ListaAños" :key="años.id" :value="años.año">
              {{ años.año }}
            </option>
          </select> -->

            <select   @change="periodo = $event.target.value" class="form-select tamaño ms-1 container">
            <option disabled selected >-- SELECCIONAR AÑO --</option>
            <option v-for="año in años" :key="año.value" :value="año.value">
              {{ año.label }}
            </option>
          </select>
        </div>

        <div class="col col-2">
          <button class="btn btn-danger tamaño my-4" @click="getAttributes()">
            Mostrar
          </button>
        </div>
      </div>


      
      <div class="d-flex justify-content-end">
        <label for="" class="tamaño mt-1">Buscar:</label>
          <input
          class="form-control  ms-2  me-1 py-1 w-25 tamaño"
          type="text"
          aria-label=".form-control-lg example"
          placeholder="Nro de cuenta"
          v-model="filterField"
          @input="Filtrado"
        />
        
      </div>

      <div v-if="mostrarTabla">

        <div class="table-responsive mt-3">
          <table class="table table-bordered">
            <thead class="bg-solimano tamaño text-white text-center">
              <tr>
                <th scope="col">RUC EMPRESA</th>
                <th scope="col">AÑO</th>
                <th scope="col">NRO CUENTA</th>
                <th scope="col">NOMBRE CUENTA</th>
                <th scope="col">NUMERO CUENTA H1</th>
                <th scope="col">NOMBRE CUENTA H1</th>
                <th scope="col">ACCION</th>
              </tr>
            </thead>
            <tbody
              v-for="(post, index) in TablaPrincipal.slice(
                NUM_RESULTS - 6,
                NUM_RESULTS
              )"
              :key="index.id"
            >
              <tr class="tamaño">
                <td>{{ post.rucEmpresa }}</td>
                <td>{{ post.ejer }}</td>
                <td>{{ post.nroCta }}</td>
                <td>{{ post.nomCta }}</td>
                <td>{{ post.nroCtaH1 }}</td>
                <td>{{ post.nomCtaH1 }}</td>
                <td>
                  <button
                    @click="MandarParams(post)"
                    class="btn btn-warning"
                    v-b-modal.modal-center
                  >
                    <i class="bi bi-pencil"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <b-modal
          id="modal-center"
          centered
          title="EDITAR CUENTAS"
          ok-only
          no-cancel-on-esc
          @ok="guardarCambios"
        >
          <label class="tamaño"> Ejercicio:</label>
          <input
            type="text"
            class="tamaño form-control"
            disabled
            v-model="ejerParams"
          />

          <label class="tamaño" for="">Empresa Ruc:</label>
          <input
            type="text"
            class="tamaño form-control"
            disabled
            v-model="rucEmpresaParams"
          />

          <label for="" class="tamaño">N° Cuenta:</label>
          <input
            type="text"
            class="tamaño form-control"
            disabled
            v-model="nroCuentaParams"
          />

          <label for="" class="tamaño">N° Cuenta H1</label>
          <input
            type="text"
            class="tamaño form-control"
            v-model="nroCtaH1Params"
          />

          <label for="" class="tamaño">N° nombre Cuenta H1</label>
          <input
            type="text"
            class="tamaño form-control"
            v-model="nomCtaH1Params"
          />
        </b-modal>

        <div class="d-flex mt-3 mb-2 tamaños">
          <button
            class="btn btn-dark mx-4 tamaños"
            @click="retroceso"
            :disabled="noRetroceder"
          >
            <span aria-hidden="true"> {{ retroceder }}</span>
          </button>
          <button
            class="text-white px-3 rounded-2 py-2 btn-solimano"
            :disabled="true"
          >
            {{ pag }}
          </button>

          <button class="btn btn-ligth border border-0">/</button>

          <button
            class="text-white px-3 rounded-2 py-2 btn-solimano"
            :disabled="true"
          >
            {{ Math.ceil(this.TablaPrincipal.length / 6) }}
          </button>
          <button
            class="btn btn-dark mx-4 tamaños"
            @click="aumentar"
            :disabled="noAvanzar"
          >
            <span aria-hidden="true">{{ avanzar }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  name: "SolimanoLogMantCuenta",

  data() {
    return {
      filterField:"",
      Empresas: [],
      ListaAños: [
        { id: 1, año: 2015 },
        { id: 2, año: 2016 },
        { id: 3, año: 2017 },
        { id: 4, año: 2018 },
        { id: 5, año: 2019 },
        { id: 6, año: 2020 },
        { id: 7, año: 2021 },
        { id: 8, año: 2022 },
        { id: 9, año: 2023 },
        { id: 10, año: 2024 },
      ],

      periodo: "",
      empresaRuc: "",
      TablaPrincipal: [],
      NUM_RESULTS: 6,
      noAvanzar: false,
      noRetroceder: false,
      retroceder: "<<",
      avanzar: ">>",
      pag: 1,
      mostrarTabla: false,

      ejerParams: "",
      nroCuentaParams: "",
      rucEmpresaParams: "",
      nomCtaH1Params: "",
      nroCtaH1Params: "",
    };
  },

  created() {
    this.apiEmpresa();
  },

   computed: {
    años() {
      const inicio = 2015; // año desde donde quieres empezar
      const actual = new Date().getFullYear();

      return Array.from(
        { length: actual - inicio + 1 },
        (_, i) => {
          const year = inicio + i;
          return {
            value: year.toString(),
            label: year.toString()
          };
        }
      );
    },

  },
 

  methods: {
    getAttributes() {
      this.mostrarTabla = false;
      this.axios
        .get(
          `Contabilidad/ListarPlanCtas?rucEmpresa=${this.empresaRuc}&periodo=${this.periodo}`
        )
        .then((r) => {
          console.log(r.data);
          this.TablaPrincipal = r.data;
          this.mostrarTabla = true;
        });
    },

    apiEmpresa() {
      this.axios.get(`Empresa/ListaEmpresa`).then((r) => {
        console.log(r.data);
        this.Empresas = r.data;
      });
    },

    Filtrado(){   
      if(this.filterField.length != 0){
        this.TablaPrincipal = []

        this.axios.get(`Contabilidad/BusquedaNroCuenta?rucEmpresa=${this.empresaRuc}&periodo=${this.periodo}&nroCta=${this.filterField}`).then(r=>{
        console.log(r.data)
        this.TablaPrincipal = r.data
      })
      }else{
        this.getAttributes()
      }
    },

    MandarParams(itemsParams) {
      console.log(itemsParams);
      this.ejerParams = itemsParams.ejer;
      this.nroCuentaParams = itemsParams.nroCta;
      this.rucEmpresaParams = itemsParams.rucEmpresa;
      this.nomCtaH1Params = itemsParams.nomCtaH1;
      this.nroCtaH1Params = itemsParams.nroCtaH1;
    },

    guardarCambios() {
      console.log("cancelar");
      const from = {
        rucEmpresa: `${this.rucEmpresaParams}`,
        ejer: `${this.ejerParams}`,
        nroCta: `${this.nroCuentaParams}`,
        nroCtaH1: `${this.nroCtaH1Params}`,
        nomCtaH1: `${this.nomCtaH1Params}`,
      };
      this.axios.put(`Contabilidad/ModificarCuenta`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se realizó cambios",
            showConfirmButton: false,
            timer: 2000,
          });

          this.getAttributes()
        }
      });
    },

    retroceso() {
      if (this.NUM_RESULTS === 6) {
        // this.retro = false;
        //  this.avanzar = true;
        this.noRetroceder = true;
      } else {
        // this.retro = true;
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
        //  this.avanzar = true
      }
    },

    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.TablaPrincipal.length) {
        this.noAvanzar = true;
      }
      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.tamaño {
  font-size: 0.65rem;
}

.tituloColor {
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
  color: #002c5d;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.bg-solimano {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}
</style>
